import React from 'react';
import Button from './Button';
import { StyledStats } from './styles/Stats.styled';

export default function StatsPage(props) {
	return (
		<StyledStats>
			<div className='stats--congratz'>
				<span>Congratulations</span>
				<br />
				<span>🎉🎉🎉</span>
			</div>
			<div className='stats--overview'>
				<p className='statsPage--stats-recordMessage'>
					It took you <br />
					🎲 <b>{props.numOfRolls}</b> rolls | ⏱️ <b>{props.timer}</b> s <br />
					to finish Tenzi.{' '}
				</p>
				<hr className='divider'></hr>
				<h2>{props.recordMessage}</h2>
			</div>
			<Button text='NEW GAME' ng={true} onClick={props.rollBtnHandler} />
		</StyledStats>
	);
}
